export interface Config {
  allowSearch: boolean;

  searchEnabled: boolean;
  headerEnabled: boolean;
  orderEnabled: boolean;
  orderEventOnly?: boolean;
  paginationEnabled: boolean;
  clickEvent: boolean;
  selectRow: boolean;
  selectCol: boolean;
  selectCell: boolean;
  rows: number;
  additionalActions: boolean;
  serverPagination: boolean;
  isLoading: boolean;
  detailsTemplate: boolean;
  groupRows: boolean;
  paginationRangeEnabled: boolean;
  collapseAllRows: boolean;
  checkboxes: boolean;
  radio?: boolean;
  resizeColumn: boolean;
  fixedColumnWidth: boolean;
  horizontalScroll: boolean;
  logger: boolean;
  showDetailsArrow?: boolean;
  showContextMenu?: boolean;
  paginationMaxSize?: number;
  threeWaySort?: boolean;
  columnReorder?: boolean;
  reorderDelay?: number;
  onDragOver?: boolean;
  tableLayout: {
    style: STYLE | string | null;
    borderless: boolean | null;
    hover: boolean | null;
    striped: boolean | null;
  };
  defaultSortColumn?: string;
  defaultSortDirection?: string;
}

export enum STYLE {
  TINY = 'tiny',
  BIG = 'big',
  NORMAL = 'normal',
}
